'use strict';


export class uxCookie {
	
	
static get(name) {
		let matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		));
		return matches ? decodeURIComponent(matches[1]) : undefined;
	}

	/**
	* options contains:
	* 	expires:
	* 		Digit - time of live at minutes.
	* 		Expire Date (past for delete, 0 for session)
	* 	path: default /
	* 	domain: default is current domain
	* 	secure: ssl only
	*/	
	static set(name, value, options = {}) {
		let expires = options.expires;

		if (typeof expires == "number" && expires) {
			let d = new Date();
			d.setTime(d.getTime() + expires * 1000);
			expires = options.expires = d;
		}
		if (expires && expires.toUTCString) {
			options.expires = expires.toUTCString();
		}

		value = encodeURIComponent(value);

		let updatedCookie = name + "=" + value;

		for (let propName in options) {
			
			if (document.DEV_MODE && (propName == 'secure')) {				
				continue;
			}
			
			updatedCookie += "; " + propName;
			let propValue = options[propName];

			if (propValue !== true) {
				updatedCookie += "=" + propValue;
			}
		}

		document.cookie = updatedCookie;
	}

	static delete(name) {
	  setCookie(name, "", {
		expires: -1
	  })
	}

}